import { Selector } from 'redux/modules/types';
import { createSelector } from 'reselect';
import { MonthlyReportState } from './types';

const selectState: Selector<MonthlyReportState> = (state) =>
  state.monthlyReport;

export const selectMonthlyReport = createSelector(
  selectState,
  (state) => state.report,
);

export const selectMonthlyReportLoading = createSelector(
  selectState,
  (state) => state.loading,
);

export const selectMonthlyReportError = createSelector(
  selectState,
  (state) => state.error,
);
